if (!customElements.get('poshtik-delivery-checker')) {
  customElements.define(
    'poshtik-delivery-checker',
    class PoshtikDeliveryChecker extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input');
        this.message = this.querySelector('[aria-live]');

        if (!this.form || !this.input || !this.message) return;

        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          const pincode = this.input.value.replace(/\D/g, '').slice(0, 6);
          this.input.value = pincode;

          if (pincode.length !== 6) {
            this.setAttribute('data-state', 'error');
            this.message.textContent = 'Please enter a valid 6-digit pincode.';
            this.input.focus();
            return;
          }

          this.setAttribute('data-state', 'success');
          this.message.textContent = this.dataset.successMessage;
        });

        this.input.addEventListener('input', () => {
          this.input.value = this.input.value.replace(/\D/g, '').slice(0, 6);
          this.removeAttribute('data-state');
        });
      }
    }
  );
}

const buildPoshtikPurchaseRows = (scope = document) => {
  scope.querySelectorAll('.poshtik-product .product__info-container').forEach((container) => {
    if (container.querySelector(':scope > .poshtik-product__purchase-row')) return;

    const price = container.querySelector(':scope > [id^="price-"]');
    const quantity = container.querySelector(':scope > .product-form__quantity');
    if (!price || !quantity) return;

    const tax = container.querySelector(':scope > .product__tax');
    const installment = container.querySelector(':scope > .poshtik-product__installment');
    const row = document.createElement('div');
    const priceStack = document.createElement('div');

    row.className = 'poshtik-product__purchase-row';
    priceStack.className = 'poshtik-product__price-stack';
    container.insertBefore(row, price);
    row.append(priceStack, quantity);
    priceStack.append(price);
    if (tax) priceStack.append(tax);
    if (installment) priceStack.append(installment);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => buildPoshtikPurchaseRows());
} else {
  buildPoshtikPurchaseRows();
}

document.addEventListener('shopify:section:load', (event) => buildPoshtikPurchaseRows(event.target));

if (!customElements.get('poshtik-related-card')) {
  customElements.define(
    'poshtik-related-card',
    class PoshtikRelatedCard extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select[name="id"]');
        this.price = this.querySelector('[data-related-price]');
        this.button = this.querySelector('button[type="submit"]');
        if (!this.select) return;

        this.select.addEventListener('change', () => {
          const option = this.select.selectedOptions[0];
          if (this.price && option.dataset.price) this.price.textContent = option.dataset.price;
          if (this.button) this.button.disabled = option.dataset.available !== 'true';
        });
      }
    }
  );
}
